export enum AuthorityConsumable {
  REGISTER_CONSUMABLE_EDIT_STOCK = '1.9.6',
  REGISTER_CONSUMABLE_REPORTS = '1.9.5',
  REGISTER_CONSUMABLE_EDIT = '1.9.4',
  REGISTER_CONSUMABLE_DELETE = '1.9.3',
  REGISTER_CONSUMABLE_ADD = '1.9.2',
  REGISTER_CONSUMABLE_VIEW = '1.9.1',
  REGISTER_CONSUMABLE_REGISTRATION = '1.9',
}
